import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon, Image } from "react-bootstrap";
import { format } from 'date-fns';

const renderRow = (newsModel, onEdit, isReadOnly, onDelete) => {
    const imageUrl = `api/settings/news/image/${newsModel.Id}?t=${new Date().getTime()}`;

    return (
        <tr key={newsModel.Id}>
            <td><Image src={imageUrl} height="50" /></td>
            <td>{newsModel.Id}</td>
            <td>{newsModel.Title}</td>
            <td>{newsModel.Description}</td>
            <td>{format(new Date(newsModel.PublishDate), 'DD.MM.YYYY')}</td>
            <td>
                <Glyphicon 
                    glyph='trash' 
                    className={`glyphicon-trash${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onDelete(newsModel)} 
                    title='Удалить' />
            </td>
            <td>
                <Glyphicon 
                    glyph='pencil' 
                    className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onEdit(newsModel)} 
                    title='Изменить' />
            </td>
        </tr>
    );
};

export const Table = ({ news, fetching, onEdit, isReadOnly, onDelete }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td></td>
                        <td>№</td>
                        <td>Название</td>
                        <td>Описание</td>
                        <td>Дата публикации</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {news.map(d => renderRow(d, onEdit, isReadOnly, onDelete))}
                </tbody>
            </table>}
    </div>
);



// WEBPACK FOOTER //
// ./src/components/settings/news/Table.jsx